<label class="{{ cssClass }} side-{{ side }}" [class.disabled]="disabled">
  <input type="radio" [name]="groupName" [value]="value" [checked]="isChecked" [class.checked]="isChecked"
         [class.selected]="isChecked" [disabled]="disabled" [id]="inputId" [attr.aria-checked]="isChecked"
         [attr.aria-disabled]="disabled ? 'true' : null" [attr.aria-label]="ariaLabel"
         [attr.aria-describedby]="ariaDescribedby" (change)="onRadioChange($event)" />
  @if (cssClass === 'radio-container') {
  <span class="checkmark"></span>
  }
  <ng-content></ng-content>
</label>